import styled, { useTheme } from 'styled-components';

import { richTextToReactNode } from '@seuk/cms-api-client';
import { Icon } from '@seuk/design-system/atoms';
import { isDocumentUrl } from '@seuk/util';

const Link = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1rem;
  ${({ theme }) => theme.typography.paragraph.medium.normal};
  color: ${({ theme }) => theme.palette.text.onSurface.subtle};

  & > * {
    margin-right: 0.5rem;
  }
`;

export default function LinkItem({ url, href, label, description, trackInfo }) {
  const theme = useTheme();
  const isExternal = isDocumentUrl(href) === false;

  return (
    <div>
      <Link href={url ?? href} target="_blank" rel="noopener noreferrer" key={`${trackInfo.pageTitle}:${href}`}>
        <Icon color={theme.palette.focus.strong} name={isExternal ? 'ExternalLink' : 'Documents'} /> {label}
      </Link>
      {description ? richTextToReactNode(description) : null}
    </div>
  );
}
